import { setupWorker } from 'msw';
import userHandlers from './handlers/userHandlers';
import wizardStepsHandlers from './handlers/stepsHandlers';
import mfaHandlers from './handlers/mfaHandlers';
import staffHandlers from './handlers/staffListHandlers';
import staffRolesHandlers from './handlers/staffRolesHandlers';
import addressHandlers from './handlers/addressHandlers';
import googlePlacesHandlers from './handlers/googlePlacesHandlers';
import categoryHandlers from './handlers/categoryHandlers';
import productHandlers from './handlers/productHandlers';
import personalInformationHandlers from './handlers/personalInformationHandlers';
import businessInformationHandlers from './handlers/businessInformationHandlers';
import sidekickAiHandlers from './handlers/sidekickAiHandlers';
import kycHandlers from './handlers/kycHandlers';
import catalogHandlers from './handlers/catalogHandlers';

const handlers = [
  // ...userHandlers(500),
  // ...wizardStepsHandlers,
  // ...personalInformationHandlers,
  // ...businessInformationHandlers,
  // ...mfaHandlers,
  // ...staffHandlers,
  // ...staffRolesHandlers,
  // ...addressHandlers,
  // ...googlePlacesHandlers,
  // ...categoryHandlers(),
  // ...productHandlers(),
  // ...sidekickAiHandlers,
  // ...kycHandlers,
  // ...catalogHandlers(),
];

const server = setupWorker(...handlers);

export default server;
